import TimeOfUseOverview from '@/authenticated/components/UtilityUsage/UsageOverview/TimeOfUseOverview'
import { SeasonalRateSummary } from '@/types'

type Props = {
  seasonalRateSummary: SeasonalRateSummary[] | null
}

/**
 * Renders the selected plan's time-of-use rates inside the selection page. Drops
 * the "Off-peak until XX" current-rate header (not meaningful while choosing a
 * plan) and wraps the rate overview in a single light container so it does not
 * read as a card-within-a-card. Renders nothing when there are no rates.
 *
 * Theming (Inter typography + the rate-viz palette) lives in `TimeOfUseOverview`
 * itself, so no theme wrapper is needed here.
 */
export default function PlanRatePreview({ seasonalRateSummary }: Props) {
  if (!seasonalRateSummary || seasonalRateSummary.length === 0) {
    return null
  }

  return (
    <div className="shadow-spread p-4 rounded-2xl">
      <TimeOfUseOverview
        seasonalRateSummary={seasonalRateSummary}
        showCurrentRateHeader={false}
      />
    </div>
  )
}
